import settings from '~/settings';

const mediaPath = settings.mediaPath || '';

export const getImagePath = (url?: string) => {
  if (!url) {
    return '';
  }

  return `${mediaPath}${url}`;
};
